import { AbstractModel } from './abstract-model';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class Provider extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  code: string;

  @autoserialize
  description: string;

  @autoserialize
  phoneNumber: string;

  @autoserialize
  emailAddress: string;

  @autoserialize
  mediRoutesEnabled: boolean;

  @autoserialize
  mediRoutesKey: string;

  @autoserialize
  mobileAppEnabled: boolean;

  @autoserialize
  proxyDriverId: number;
}
